import React, { useContext, useMemo } from 'react';

export type SkeletonContextValue = {
  isLoading: boolean;
};

const Context = React.createContext<SkeletonContextValue>({
  isLoading: false
});

function SkeletonProvider({
  children,
  isLoading = false
}: React.PropsWithChildren<Partial<SkeletonContextValue>>) {
  const value: SkeletonContextValue = useMemo(
    () => ({
      isLoading
    }),
    [isLoading]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

function useSkeletonContext() {
  return useContext(Context);
}

export { useSkeletonContext, SkeletonProvider };
